import useEntity from "../../hooks/useUserAddress";
import UserAddressDetail from "../../components/userAddress/UserAddressDetail/UserAddressDetail";
import UserAddressScoped from "../../components/userAddress/UserAddressDetail/UserAddressScoped";
import UserAddressTabs from "../../components/userAddress/UserAddressDetail/UserAddressTabs";
import { useGetUserAddressQuery } from "../../apis/UserAddress.api";
import { PrimaryUserAddress } from "../../types/models/UserAddress";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserAddressDetailPage = () => {

    useTitle(t`Details User Address`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { userAddressId: id } = useParams();

    const { data, refetch } = useGetUserAddressQuery(PrimaryUserAddress.fromPath(id))
    const { deleteUserAddress } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteUserAddress(data, '..')
    }, [data, deleteUserAddress])

    if (id === 'scoped') {
        return (<UserAddressScoped/>)
    }

    return (
        <Box data-testid="UserAddress-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <UserAddressDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em" }}>
                    
                    { 
        session.hasPermission('', 'applications/address/entities/UserAddresses/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="UserAddress-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <UserAddressTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default UserAddressDetailPage;
